import {Routes} from '@angular/router';

export const knowledgebaseRoutes: Routes = [
  {
    path: ':categoryId/:articleId',
    loadComponent: () => import('../modules/knowledge-base/knowledge-base.component').then((m) => m.KnowledgeBaseComponent),
    data: {preload: 'base'},
  },
  {
    path: ':categoryId',
    loadComponent: () => import('../modules/knowledge-base/knowledge-base.component').then((m) => m.KnowledgeBaseComponent),
    data: {preload: 'base'},
  },
  {
    path: '',
    loadComponent: () => import('../modules/knowledge-base/knowledge-base.component').then((m) => m.KnowledgeBaseComponent),
    data: {preload: 'base'},
  }
];
